import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { STATUS_OBJECT } from 'src/app/dummy/status';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { PrintService } from 'src/app/services/print.service';
import { TABS } from 'src/app/dummy/tab';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { ResourceStore } from 'src/app/stores/resources/resource.store';
import { MatDialog, MatSnackBar } from '@angular/material';
import { DeleteComponent } from 'src/app/components/delete/delete.component';
import { AddTrainingTutorComponent } from '../add-training-tutor/add-training-tutor.component';

@Component({
  selector: 'app-training-tutor',
  templateUrl: './training-tutor.component.html',
  styleUrls: ['./training-tutor.component.scss']
})
export class TrainingTutorComponent implements OnInit {
  @ViewChild('PRINT_TABLE', {static:false}) PRINT_TABLE: ElementRef;
  tabs = TABS.TUTORS;
  DISPLAY_STATUS_KEY: any;

  constructor(
    private route: ActivatedRoute,
    public store: ResourceStore,
    private auth: AuthStore,
    public ps: PrintService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
  ) { }

  async ngOnInit() {
    this.DISPLAY_STATUS_KEY = STATUS_OBJECT.submitted;
    const { selectedCompanyKey } = this.auth;
    this.store.fetchData(COLLECTION_NAME.TUTORS, this.DISPLAY_STATUS_KEY.key, selectedCompanyKey)
  }

  create(item?: any) {
    const dialogRef = this.dialog.open(AddTrainingTutorComponent, {
      data: { ITEM: item || null },
      panelClass: "register-test-overlay-panel",
      width: "35vw",
      height: "100vh",
      disableClose: true,
      role: "dialog"
    });
    dialogRef.updatePosition({ top: "0", right: "0", bottom: "0" });
    dialogRef.afterClosed().subscribe(result => { });
  }

  delete(item: any) {
    let dialogRef = this.dialog.open(DeleteComponent, {
      data: item,
      panelClass: 'cs-overlay-panel',
      width: '',
      height: '',
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.store.delete(COLLECTION_NAME.TUTORS, item, (success) => {
          if (success) {
            this.snackBar.open("Tutor has been deleted successful.", "Done", { duration: 2500 });
          }
        })
      }
    });
  }

}
